import {Title} from '@treez-ui/core/layout';
import {TitleSize} from '@treez-ui/core/layout/Title';
import React, {FunctionComponent} from 'react';
import BrowseBrandTreezPrompt from '~/modules/widgets/BrowseBrandTreezPrompt';

interface Props {
    redirectToBrandTreez: () => void;
    openProductForm: () => void;
}

export const NoProductsFoundPrompt: FunctionComponent<Props> = (props: Props) => {
    const {redirectToBrandTreez, openProductForm} = props;

    return (
        <div className="no-products-found">
            <Title text="No products were found" size={TitleSize.MEDIUM} />
            <BrowseBrandTreezPrompt
                redirectToBrandTreez={redirectToBrandTreez}
                openProductForm={openProductForm}
            />
        </div>
    );
};

export default NoProductsFoundPrompt;
